// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet-async';
// import { motion } from 'framer-motion';
// import { useForm } from 'react-hook-form';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

// const Contact = () => {
//   const [loading, setLoading] = useState(false);
//   const { register, handleSubmit, reset, formState: { errors } } = useForm();

//   const onSubmit = async (data) => {
//     setLoading(true);
//     try {
//       await axios.post('/api/contact', data);
//       toast.success('Message sent successfully! We\'ll get back to you soon.');
//       reset();
//     } catch (error) {
//       toast.error(error.response?.data?.message || 'Failed to send message. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const contactInfo = [
//     {
//       icon: <FaMapMarkerAlt className="text-2xl text-primary-600" />,
//       title: 'Visit Us',
//       details: ['123 Tech Street', 'Silicon Valley, CA 94025', 'United States']
//     },
//     {
//       icon: <FaPhone className="text-2xl text-primary-600" />,
//       title: 'Call Us',
//       details: ['+1 (123) 456-7890', '+1 (987) 654-3210']
//     },
//     {
//       icon: <FaEnvelope className="text-2xl text-primary-600" />,
//       title: 'Email Us',
//       details: ['info@versaimmortal.com', 'support@versaimmortal.com']
//     },
//     {
//       icon: <FaClock className="text-2xl text-primary-600" />,
//       title: 'Business Hours',
//       details: ['Monday – Friday: 9am – 6pm', 'Saturday: 10am – 4pm', 'Sunday: Closed']
//     }
//   ];

//   return (
//     <>
//       <Helmet>
//         <title>Contact Us - Versaimmortal Infotech</title>
//         <meta name="description" content="Get in touch with Versaimmortal Infotech. We're here to answer your questions and discuss your technology needs." />
//         <meta name="keywords" content="contact, IT company, get in touch, support" />
//         <meta property="og:title" content="Contact Versaimmortal Infotech" />
//         <meta property="og:description" content="Reach out to us for any inquiries or project discussions." />
//         <meta property="og:type" content="website" />
//         <link rel="canonical" href="https://versaimmortal.com/contact" />
//       </Helmet>

//       {/* Hero Section */}
//       <section className="relative bg-gradient-to-r from-primary-900 to-primary-700 text-white py-24">
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="relative container mx-auto px-4 text-center">
//           <motion.h1
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             className="text-4xl md:text-5xl font-bold mb-6"
//           >
//             Contact Us
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6, delay: 0.2 }}
//             className="text-xl max-w-3xl mx-auto"
//           >
//             Have a question or ready to start your next project? We'd love to hear from you.
//           </motion.p>
//         </div>
//       </section>

//       {/* Contact Info Cards */}
//       <section className="py-16 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {contactInfo.map((item, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition text-center"
//               >
//                 <div className="flex justify-center mb-4">{item.icon}</div>
//                 <h3 className="text-lg font-semibold mb-3">{item.title}</h3>
//                 {item.details.map((detail, i) => (
//                   <p key={i} className="text-gray-600 text-sm">{detail}</p>
//                 ))}
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Contact Form & Map */}
//       <section className="py-16 bg-gray-50">
//         <div className="container mx-auto px-4">
//           <div className="grid lg:grid-cols-2 gap-12">
//             {/* Form */}
//             <motion.div
//               initial={{ opacity: 0, x: -20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//               viewport={{ once: true }}
//             >
//               <h2 className="text-3xl font-bold text-gray-900 mb-6">Send Us a Message</h2>
//               <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Your Name *</label>
//                   <input
//                     type="text"
//                     {...register('name', { required: 'Name is required' })}
//                     className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                       errors.name ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                     placeholder="John Doe"
//                   />
//                   {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
//                   <input
//                     type="email"
//                     {...register('email', { 
//                       required: 'Email is required',
//                       pattern: {
//                         value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
//                         message: 'Invalid email address'
//                       }
//                     })}
//                     className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                       errors.email ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                     placeholder="john@example.com"
//                   />
//                   {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number (Optional)</label>
//                   <input
//                     type="tel"
//                     {...register('phone')}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
//                     placeholder="+1 (123) 456-7890"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Subject *</label>
//                   <input
//                     type="text"
//                     {...register('subject', { required: 'Subject is required' })}
//                     className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                       errors.subject ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                     placeholder="How can we help you?"
//                   />
//                   {errors.subject && <p className="mt-1 text-sm text-red-600">{errors.subject.message}</p>}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">Message *</label>
//                   <textarea
//                     rows="5"
//                     {...register('message', { 
//                       required: 'Message is required',
//                       minLength: { value: 10, message: 'Message must be at least 10 characters' }
//                     })}
//                     className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
//                       errors.message ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                     placeholder="Tell us about your project..."
//                   ></textarea>
//                   {errors.message && <p className="mt-1 text-sm text-red-600">{errors.message.message}</p>}
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition duration-300 disabled:bg-primary-300"
//                 >
//                   {loading ? 'Sending...' : 'Send Message'}
//                 </button>
//               </form>
//             </motion.div>

//             {/* Map */}
//             <motion.div
//               initial={{ opacity: 0, x: 20 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6 }}
//               viewport={{ once: true }}
//               className="h-full"
//             >
//               <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Location</h2>
//               <div className="bg-gray-200 rounded-lg overflow-hidden shadow-lg h-96">
//                 <iframe
//                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.636717520492!2d-122.086246684688!3d37.42199997982164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fba5c3b7e7c0b%3A0xa0b3b3b3b3b3b3b3!2sGoogleplex!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
//                   width="100%"
//                   height="100%"
//                   style={{ border: 0 }}
//                   allowFullScreen=""
//                   loading="lazy"
//                   title="Office Location"
//                 ></iframe>
//               </div>
//               <p className="mt-4 text-gray-600">
//                 <FaMapMarkerAlt className="inline mr-2 text-primary-600" />
//                 123 Tech Street, Silicon Valley, CA 94025, United States
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* FAQ / Additional CTA (Optional) */}
//       <section className="py-16 bg-white">
//         <div className="container mx-auto px-4 text-center">
//           <h2 className="text-3xl font-bold text-gray-900 mb-4">Prefer to reach us directly?</h2>
//           <p className="text-xl text-gray-600 mb-8">
//             Call us at <a href="tel:+11234567890" className="text-primary-600 font-semibold">+1 (123) 456-7890</a> or email <a href="mailto:info@versaimmortal.com" className="text-primary-600 font-semibold">info@versaimmortal.com</a>
//           </p>
//           <p className="text-gray-600">
//             We typically respond within 24 hours on business days.
//           </p>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Contact;




















import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await axios.post('/api/contact', data);
      toast.success('Message sent successfully! We\'ll get back to you soon.');
      reset();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const contactInfo = [
    // {
    //   icon: <FaMapMarkerAlt className="text-2xl text-primary-600" />,
    //   title: 'Visit Us',
    //   details: ['123 Tech Street', 'Silicon Valley, CA 94025', 'United States']
    // },
    // {
    //   icon: <FaPhone className="text-2xl text-primary-600" />,
    //   title: 'Call Us',
    //   details: ['+1 (123) 456-7890', '+1 (987) 654-3210']
    // },
    {
      icon: <FaEnvelope className="text-2xl text-primary-600" />,
      title: 'Email Us',
      details: ['info@versaimmortal.com', 'support@versaimmortal.com']
    },
    {
      icon: <FaClock className="text-2xl text-primary-600" />,
      title: 'Business Hours',
      details: ['Monday – Friday: 9am – 6pm', 'Saturday: 10am – 4pm', 'Sunday: Closed']
    }
  ];

  return (
    <>
      <Helmet>
        <title>Contact Us - Versaimmortal Infotech</title>
        <meta name="description" content="Get in touch with Versaimmortal Infotech. We're here to answer your questions and discuss your technology needs." />
        <meta name="keywords" content="contact, IT company, get in touch, support" />
        <meta property="og:title" content="Contact Versaimmortal Infotech" />
        <meta property="og:description" content="Reach out to us for any inquiries or project discussions." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://versaimmortal.com/contact" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-primary-900 to-primary-700 text-white py-24">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative container mx-auto px-4 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold mb-6"
          >
            Contact Us
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-xl max-w-3xl mx-auto"
          >
            Have a question or ready to start your next project? We'd love to hear from you.
          </motion.p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {contactInfo.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition text-center"
              >
                <div className="flex justify-center mb-4">{item.icon}</div>
                <h3 className="text-lg font-semibold mb-3">{item.title}</h3>
                {item.details.map((detail, i) => (
                  <p key={i} className="text-gray-600 text-sm">{detail}</p>
                ))}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form (only) */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Send Us a Message</h2>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name *</label>
                <input
                  type="text"
                  {...register('name', { required: 'Name is required' })}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                    errors.name ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="John Doe"
                />
                {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
                <input
                  type="email"
                  {...register('email', { 
                    required: 'Email is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address'
                    }
                  })}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                    errors.email ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="john@example.com"
                />
                {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number (Optional)</label>
                <input
                  type="tel"
                  {...register('phone')}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  placeholder="+1 (123) 456-7890"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Subject *</label>
                <input
                  type="text"
                  {...register('subject', { required: 'Subject is required' })}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                    errors.subject ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="How can we help you?"
                />
                {errors.subject && <p className="mt-1 text-sm text-red-600">{errors.subject.message}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Message *</label>
                <textarea
                  rows="5"
                  {...register('message', { 
                    required: 'Message is required',
                    minLength: { value: 10, message: 'Message must be at least 10 characters' }
                  })}
                  className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 ${
                    errors.message ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Tell us about your project..."
                ></textarea>
                {errors.message && <p className="mt-1 text-sm text-red-600">{errors.message.message}</p>}
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold hover:bg-primary-700 transition duration-300 disabled:bg-primary-300"
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </motion.div>
        </div>
      </section>

      {/* Additional contact info (commented out as requested)
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Prefer to reach us directly?</h2>
          <p className="text-xl text-gray-600 mb-8">
            Call us at <a href="tel:+11234567890" className="text-primary-600 font-semibold">+1 (123) 456-7890</a> or email <a href="mailto:info@versaimmortal.com" className="text-primary-600 font-semibold">info@versaimmortal.com</a>
          </p>
          <p className="text-gray-600">
            We typically respond within 24 hours on business days.
          </p>
        </div>
      </section>
      */}
    </>
  );
};

export default Contact;